import { CsrfTokenProvider } from '@shared-ui/security-token-context';
import * as React from 'react';

var CsrfContext = /** @class */ (function () {
    function CsrfContext(csrfToken) {
        this.csrfToken = csrfToken;
        this.setCsrfToken = this.setCsrfToken.bind(this);
    }
    CsrfContext.prototype.setCsrfToken = function (placementID, updatedCsrfToken) {
        this.csrfToken[placementID] = updatedCsrfToken;
    };
    return CsrfContext;
}());

function CsrfPlugin() {
    return {
        name: 'csrf',
        onBrowserHydrateRenderContext: function (context, next) {
            var hydratedState = context.hydratedState, setAppData = context.setAppData;
            var csrfToken = hydratedState.csrfToken;
            var csrfContext = new CsrfContext(csrfToken);
            setAppData({ csrfContext: csrfContext });
            return next(context);
        },
        onBrowserWrapRootElement: function (context, next) {
            var getAppData = context.getAppData, setRootElement = context.setRootElement;
            var csrfContext = getAppData().csrfContext;
            setRootElement(function (RootElement) { return function (props) { return (React.createElement(CsrfTokenProvider, { CsrfContext: csrfContext },
                React.createElement(RootElement, null, props.children))); }; });
            return next(context);
        },
    };
}

export { CsrfPlugin as default };
//# sourceMappingURL=browser.js.map
